import { useNavigate } from 'react-router-dom'
import { Box, Card, CardContent, Typography } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { useFarmId } from '~/common/use-farm-id'
import { TpFullscreenFab } from '~/components/tp-fullscreen-fab'
import { TaskList } from './task-list'
import { TasksContextProvider } from './context/tasks-context-provider'
import { useState } from 'react'

export const TaskListCard = () => {
  const navigate = useNavigate()
  const { farmId } = useFarmId()
  const [isMouseOver, setIsMouseOver] = useState(false)

  const handleFullscreen = () => {
    const url = farmId ? `/tasks?farmId=${farmId}` : '/tasks'
    navigate(url)
  }

  return (
    <TasksContextProvider>
      <Card
        onMouseEnter={() => setIsMouseOver(true)}
        onMouseLeave={() => setIsMouseOver(false)}
        sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', pt: 0.5 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, mb: 0 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.65rem', letterSpacing: '0.05em', pl: 1 }}>
            TASK LIST
          </Typography>
        </Box>
        <CardContent
          sx={{
            p: 0,
            flex: 1,
            overflow: 'auto',
            minHeight: 0,
            '&.MuiCardContent-root:last-child': {
              pb: 0,
            }
          }}
        >
          <TaskList />
        </CardContent>

        {isMouseOver && (
          <TpFullscreenFab onClick={handleFullscreen}>
            <Icons.Fullscreen />
          </TpFullscreenFab>
        )}
      </Card>
    </TasksContextProvider>
  )
}
